import React from 'react';
import { useSelector } from 'react-redux';
import clsx from 'clsx';
import { ArrowUpRight } from 'lucide-react';
import { getCompanyOnboardingStatusFromState } from '../../states/slices/globalSlice';
import { useNavigate } from 'react-router-dom';
import useRoute from '../../hooks/routesHook';

const SubscribedPlanIndication: React.FC = () => {
  const onboardingStatus = useSelector(getCompanyOnboardingStatusFromState);
  const planName = onboardingStatus?.companyInfo?.subscriptionPlanName;
  const { getDashboardBase } = useRoute();
  const navigate = useNavigate();

  if (!planName) {
    return null;
  }

  return (
    <div className="relative group cursor-pointer w-fit">
      <span onClick={() => navigate(`${getDashboardBase()}/settings?tab=billing`)} className="w-fit cursor-pointer text-xs text-gray-500 dark:text-darkBg-subText underline">
        {planName}
      </span>
      {/* <div
        onClick={() => navigate(`${getDashboardBase()}/settings?tab=billing`)}
        className={clsx(
          'inline-flex items-center px-4 py-[5px] rounded-full text-sm cursor-pointer font-semibold',
          'transition-all duration-300 ease-in-out cursor-default',
          'hover:scale-105 hover:shadow-lg',
          'border-2 border-opacity-30 backdrop-blur-sm',
          'transform-gpu',
          'bg-gradient-to-r from-blue-500 to-indigo-600',
          'border-blue-400',
          'shadow-lg shadow-blue-500/25',
          'hover:shadow-blue-500/40',
          'text-white drop-shadow-sm'
        )}
      >
        <div className="flex items-center space-x-2">
          <div className="w-2.5 h-2.5 rounded-full bg-white/90" />
          <span className="uppercase tracking-wide text-xs opacity-80">
            Plan
          </span>
          <span className="font-bold tracking-wide">
            {planName}
          </span>
          <span className="flex items-center justify-center w-5 h-5 rounded-full bg-white/15 ml-1">
            <ArrowUpRight className="w-3 h-3 text-white" />
          </span>
        </div>
      </div> */}
    </div>
  );
};

export default SubscribedPlanIndication;